import { render } from "./nickname.vue?vue&type=template&id=5fffdc98&scoped=true&ts=true"
import script from "./nickname.vue?vue&type=script&lang=ts"
export * from "./nickname.vue?vue&type=script&lang=ts"

import "./nickname.vue?vue&type=style&index=0&id=5fffdc98&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fffdc98"]])

export default __exports__